export default function formats() {
	const limitString = (string, limit) => {
		return string.substring(0, limit) + '...';
	};

	return { limitString };
}
